import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { PopupContactUs } from '../../../../../common/order/popup/popupContactUs'

export const ContactUs = () => {
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  // Actions
  const onOpenPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  return (
    <>
      <Element
        className="dFlex justifyContentCenter alignItemsCenter gap1"
        style={{
          border: '1px solid',
          borderColor: '#D1D1D1',
          padding: '4px 8px',
          borderRadius: 3,
        }}
      >
        <Element
          elementName="p"
          style={{
            lineHeight: '16px',
            color: '#3A414B',
            cursor: 'pointer',
          }}
          onClick={onOpenPopupContactUs}
        >
          <Translate value="score.standard.CONTACT_US" />
        </Element>
        <Icon className="icon-arrow-right" style={{ fontSize: 8 }} />
      </Element>

      <PopupContactUs
        isOpen={isOpenPopupContactUs}
        onClose={onClosePopupContactUs}
      />
    </>
  )
}
